import { render, staticRenderFns } from "./transfers.vue?vue&type=template&id=1bfffa9c&"
import script from "./transfers.vue?vue&type=script&lang=js&"
export * from "./transfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports